module.exports = __webpack_public_path__ + "img/bg.2064958d.png";